import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/$slug/")({
  head: ({ params }) => buildRouteHead(`/es/servicios/${params.slug}`),
  component: ServicePage,
});

